import * as firebase from 'firebase'
import {UserDetailInterface, UserInterface} from "@/models/User";
import { db} from "@/plugins/db";

const initPageState = () => {
    return {
        user: null as any,
        userDetail: null as any,
        fullUser: null as UserInterface | any
    };
};
export default {
    state: initPageState(),
    mutations: {
        setUser (state: any, payload: any) {
            state.user = payload
        },
        setUserDetail (state: any, payload: any) {
            state.userDetail = payload
        },
        setFullUser( state: any, payload: any){
            state.fullUser = payload
        }
    },
    actions: {
        signUserUp ({commit}: any, payload: any) {
            commit('setLoading', true);
            commit('clearError');
            firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
                .then(
                    (user: any) => {
                        commit('setLoading', false)
                        const newUser = {
                            id: user.uid,
                            name: user.displayName,
                            email: user.email,
                            photoUrl: user.photoURL
                        }
                        commit('setUser', newUser)
                    }
                )
                .catch(
                    error => {
                        commit('setLoading', false)
                        commit('setError', error)
                    }
                )
        },
        signUserIn ({commit}: any, payload: any) {
            commit('setLoading', true)
            commit('clearError')
            firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
                .then(
                    (user: any) => {
                        firebase.firestore().doc('users/'+ user.user.uid ).get().then(data => {
                            const dataUser: UserInterface | any = data.data();
                            commit('setLoading', false);
                            const newUser = {
                                id: user.user.uid,
                                name: user.user.displayName,
                                email: user.user.email,
                                photoUrl: user.user.photoURL,
                                role: dataUser.role,
                                category: dataUser.role !== 'USER' ? null : dataUser.category
                             };
                            commit('setUser', newUser);
                            commit('setFullUser', dataUser);
                            firebase.firestore().doc('userDetails/'+ user.user.uid ).get().then(da => {
                               if (da.data() == undefined){
                                   const UserDetails: UserDetailInterface = {
                                       lastClass: 1,
                                       level: 1
                                   };
                                  db.collection('userDetails').doc(user.user.uid).set(UserDetails).then(() => {
                                      commit('setUserDetail', UserDetails)
                                  }).catch(() => {
                                      commit('setLoading', false);
                                  })
                               }else {
                                   commit('setUserDetail', da.data())
                               }
                            })

                        }).catch(() => {
                            commit('setError', 'No se te ha asignado información');
                            commit('setLoading', false);
                            firebase.auth().signOut()
                        })

                    }
                )
                .catch(
                    error => {
                        commit('setLoading', false)
                        commit('setError', error)
                    }
                )
        },
        autoSignIn ({commit}: any, payload: any) {
            firebase.firestore().doc('users/'+ payload.uid ).get().then(data => {
                const dataUser: UserInterface | any = data.data();
                commit('setFullUser', dataUser);
                commit('setUser', {
                    id: payload.uid,
                    name: payload.displayName,
                    email: payload.email,
                    photoUrl: payload.photoURL,
                    role: dataUser.role,
                    category: dataUser.role !== 'USER' ? null : dataUser.category
                })
            })
        },
        resetPasswordWithEmail ({ commit }: any, payload: any) {
            const { email } = payload;
            commit('setLoading', true);
            firebase.auth().sendPasswordResetEmail(email)
                .then(
                    () => {
                        commit('setLoading', false)
                    }
                )
                .catch(
                    error => {
                        commit('setLoading', false);
                        commit('setError', error)
                    }
                )
        },
        async logout ({commit}: any) {
            await firebase.auth().signOut();
            commit('setUser', null)
        }
    },
    getters: {
        user (state: any) {
            return state.user
        },
        userDetail( state: any) {
            return state.userDetail
        }
    }
}
